import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { Administrator, administratorType } from "../../types/slices/administratorType";
import { RootState } from "../store";

const initialState:administratorType = {
    status: ApiStatus.FETCHED,
    administrators: [],
    adminSelected: {} as Administrator,
    errorMessage: undefined,
}

const adminSlice = createSlice({
    name: 'adminSlice',
    initialState,
    reducers: {
        onFetchAdmins (state, { payload }: { payload: Administrator[]}) {
            state.status = ApiStatus.FETCHED
            state.administrators = payload
            state.errorMessage = undefined
        },
        onSetSelectedAdmin (state, { payload }: { payload: Administrator }) {
            state.adminSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
            state.status = payload
        }
    }
})

export const selectAdminState = (state: RootState) => state.adminSlice
export default adminSlice.reducer
export const {
    onFetchAdmins,
    onSetSelectedAdmin,
    changeStatus
} = adminSlice.actions